import React, { useState, useEffect } from "react";
import { Box, Heading, Spinner, Alert, AlertIcon, useDisclosure } from "@chakra-ui/react";
import MissionList from "./MissionList";
import PostulerModal from "./PostulerModal";
import { getMissions } from "./MissionService";
import { useCandidature } from "../../hooks/useCandidature";

const MissionPage: React.FC = () => {
    const [missions, setMissions] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedMissionId, setSelectedMissionId] = useState<string | null>(null);
    const { postulerMission } = useCandidature();
    const accentColor = "#420073";

    useEffect(() => {
        const fetchMissions = async () => {
            try {
                const data = await getMissions();
                setMissions(data);
            } catch (err) {
                setError(err instanceof Error ? err.message : "Erreur inconnue");
            } finally {
                setLoading(false);
            }
        };
        fetchMissions();
    }, []);

    const handlePostulerClick = (missionId: string) => {
        setSelectedMissionId(missionId);
        onOpen();
    };

    const handleSubmitCandidature = async (missionId: string, file: File) => {
        try {
            return await postulerMission(missionId, file);
        } catch (err) {
            throw err;
        }
    };

    return (
        <Box p={4} maxW="container.xl" mx="auto">
            <Heading mb={8} color={accentColor}>Missions disponibles</Heading>

            {loading && (
                <Box textAlign="center">
                    <Spinner size="xl" color={accentColor} />
                </Box>
            )}

            {error && (
                <Alert status="error" mb={4}>
                    <AlertIcon />
                    {error}
                </Alert>
            )}

            {!loading && !error && (
                <MissionList
                    missions={missions}
                    onPostuler={handlePostulerClick}
                />
            )}

            <PostulerModal
                isOpen={isOpen}
                onClose={onClose}
                missionId={selectedMissionId || ""}
                onPostuler={handleSubmitCandidature}
            />
        </Box>
    );
};

export default MissionPage;